// export const BASE_URL = "http://192.168.0.3:8000";
// export const BASE_URL = "http://127.0.0.1:8000";
export const BASE_URL = "https://admin.safari.digitalcampaign.co.za"

// export const IMAGE_URL = BASE_URL;
export const IMAGE_URL = BASE_URL + "/public"

// export const FRONTEND_URL = "https://rusks.stageoptimal.co.za"
